import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsAccessRoute: InvariantJiraRoute = {
	name: 'polaris-settings-access',
	path: '/jira/settings/products/jira-product-discovery/access',
	exact: true,
};
